import React from 'react';

import { ReactComponent as SensorIcon } from '@assets/svg/devices/ic-sensor.svg';
import { ReactComponent as MoteIcon } from '@assets/svg/ic-mote-of-replace-sensor.svg';
import { ReactComponent as PhotoFrameIcon } from '@assets/svg/ic-photoframe.svg';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

const StepSensorReplaceView = ({ pointTypeIsMote }) => {
  const { t } = useTranslation();

  return (
    <div className={style.stepView}>
      <div className={style.stepViewTitle}>{t('Are you sure you want to replace this sensor?')}</div>
      <div className={style.stepViewDisclaimer}>
        <b>{t('Disclaimer')}: </b>
        {t(
          'You must replace sensors under the guidance of Waites staff to ensure warranty coverage.If you have questions, contact',
        )}{' '}
        <a className={style.supportLink} href="mailto:support@waites.net">
          support@waites.net
        </a>
        .
      </div>
      <p className={style.stepViewClarification}>
        {t('Please Prepare The Following Information To Proceed:')}
      </p>
      <div className={style.stepViewInfo}>
        <div className={style.stepViewInfoItem}>
          {pointTypeIsMote ? (
            <MoteIcon className={style.itemIcon} />
          ) : (
            <SensorIcon className={style.itemIcon} />
          )}
          <div className={style.itemText}>{t('New sensor`s hex code')}</div>
        </div>
        <div className={style.stepViewInfoItem}>
          <PhotoFrameIcon className={style.itemIcon} />
          <div className={style.itemText}>{t('Photo of the new sensor')}</div>
        </div>
      </div>
    </div>
  );
};

export default StepSensorReplaceView;
